import { render, staticRenderFns } from "./Statisticas.vue?vue&type=template&id=64538fc8"
import script from "./Statisticas.vue?vue&type=script&lang=js"
export * from "./Statisticas.vue?vue&type=script&lang=js"
import style0 from "./Statisticas.vue?vue&type=style&index=0&id=64538fc8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports